export default __webpack_public_path__ + "static/media/gameplay1.4150f374.mp4";